const FilterTypes = {
    BOOLEAN_FILTER: 0,
    OPTION_FILTER: 1,
    INPUT_FILTER: 2,
    PRICE_FILTER: 3,
    NUMBER_FILTER: 4,
};

export { FilterTypes };